import {postRequest} from "@pg-mono/request";
import {apiPath} from "@pg-mono/rp-api-routes";

import {IOurOfferFormValues} from "../components/ContactForm";

export const ourOfferPost = (jsonData: Partial<IOurOfferFormValues>) => {
    return postRequest({}, apiPath.our_offer, jsonData).then((result: IOurOfferFormValues) => {
        return result;
    });
};
import {postRequest} from "@pg-mono/request";
import {apiPath} from "@pg-mono/rp-api-routes";

import {IOurOfferFormValues} from "../components/ContactForm";

export const ourOfferPost = (jsonData: Partial<IOurOfferFormValues>) => {
    return postRequest({}, apiPath.our_offer, jsonData).then((result: IOurOfferFormValues) => {
        return result;
    });
};
